import { ofType } from "redux-observable"
import { concat, from, of, zip } from "rxjs"
import {
    catchError,
    concatMap,
    endWith,
    flatMap,
    map,
    mergeAll,
    mergeMap,
    startWith,
    switchMap,
    take
} from "rxjs/operators"

import CONSTANTS from "../../assets/js/Constants"

// Với từng function, nhận 2 stream là action$ và state$ => dùng pipe() để nối các operator lại. Lấy type của action gửi lên server => gửi api => nhận data => trả về action set của reducer
const postVehicleList = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE_REPORT.POST_VEHICLE_LIST),
        mergeMap((action) => {
            const api = async () => {
                const vehicleList = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.FUEL_CHANGE_REPORT.POST_VEHICLE_LIST,
                    {}
                )
                let arrayAction = []
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.FUEL_CHANGE_REPORT.SET_VEHICLE_LIST, {
                        data: vehicleList.data.data
                    })
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postReportDataAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE_REPORT.POST_REPORT_DATA_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const reportData = await CONSTANTS.FUNCTION.AXIOS.POST(
                    CONSTANTS.URL.FUEL_CHANGE_REPORT.POST_REPORT_DATA_ACTION,
                    action.payload
                )
                let arrayAction = []

                reportData.data.status
                    ? arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE, "Tải dữ liệu thành công")
                      )
                    : arrayAction.push(
                          CONSTANTS.FUNCTION.REDUX.DISPATCH(
                              CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                              Array.isArray(reportData.data.data.dataList) && reportData.data.data.dataList.length === 0
                                  ? "Không có dữ liệu báo cáo"
                                  : "Lỗi trong lúc tải dữ liệu"
                          )
                      )

                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.FUEL_CHANGE_REPORT.SET_REPORT_DATA_ACTION, {
                        dataList: reportData.data.data.dataList,
                        summaryInfo: reportData.data.data.summaryInfor
                    })
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

const postDownloadReportAction = (action$, state$) =>
    action$.pipe(
        ofType(CONSTANTS.ACTION.FUEL_CHANGE_REPORT.POST_DOWNLOAD_REPORT_ACTION),
        mergeMap((action) => {
            const api = async () => {
                const downloadFile = await CONSTANTS.FUNCTION.AXIOS.POST_DOWNLOAD_FILE(
                    CONSTANTS.URL.FUEL_CHANGE_REPORT.POST_DOWNLOAD_REPORT_ACTION + `${action.payload.type}`,
                    action.payload
                )
                let arrayAction = []

                if (downloadFile.status !== 200 || downloadFile.statusText !== "OK") {
                    arrayAction.push(
                        CONSTANTS.FUNCTION.REDUX.DISPATCH(
                            CONSTANTS.ACTION.SYSTEM.SHOW_MESSAGE,
                            "Lỗi trong lúc tải dữ liệu"
                        )
                    )
                    return arrayAction
                }
                
                arrayAction.push(
                    CONSTANTS.FUNCTION.REDUX.DISPATCH(CONSTANTS.ACTION.FUEL_CHANGE_REPORT.SET_DOWNLOAD_REPORT_ACTION, {
                        data: downloadFile.data
                    })
                )
                return arrayAction
            }

            return concat(
                from(api()).pipe(
                    mergeMap((res) => {
                        return concat(from(res))
                    }),
                    catchError((error) => CONSTANTS.FUNCTION.REDUX.ERROR(error))
                )
            )
        })
    )

export default {
    postVehicleList,
    postReportDataAction,
    postDownloadReportAction
}
